import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { CITIES } from "@/data/cities";

export const ServiceAreas = () => {
  return (
    <section id="areas" data-testid="service-areas-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e02329] mb-3">Service Areas</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1c4f9c]">
            Serving commercial clients throughout Florida
          </h2>
          <p className="mt-4 text-base text-slate-600">
            Explore our dedicated commercial cleaning pages for each community we serve.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {CITIES.map((city, i) => (
            <Link
              key={city.slug}
              to={`/commercial-cleaning/${city.slug}`}
              data-testid={`area-${i}`}
              className="group flex flex-col items-start gap-3 border-2 border-slate-200 p-6 rounded-sm hover:border-[#e02329] hover:bg-[#1c4f9c] transition-colors duration-300"
            >
              <MapPin size={24} className="text-[#e02329] group-hover:text-[#ff6b70] transition-colors duration-300" />
              <span className="text-lg font-bold text-[#1c4f9c] group-hover:text-white transition-colors duration-300">{city.name}</span>
              <span className="text-xs font-medium text-slate-400 group-hover:text-blue-200 transition-colors duration-300">{city.region}</span>
              <span className="mt-2 inline-flex items-center gap-1 text-xs font-bold text-[#e02329] group-hover:text-white transition-colors duration-300">
                View page <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-200" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
